import { Component, Input } from '@angular/core';
import { PropositionMenuOption } from '../proposition-menu/proposition-menu.component';
import { NavController } from '@ionic/angular';

@Component({
  selector: 'ark-lib-proposition-comment-reply',
  templateUrl: './proposition-comment-reply.component.html',
  styleUrl: './proposition-comment-reply.component.css',
})
export class PropositionCommentReplyComponent {
  @Input() item: any;

  menuOptions: PropositionMenuOption[] = [
    {
      name: 'Report illegal content',
      icon: 'report-flag',
      handler: () =>
        this.navController.navigateForward(
          `/report/${this.item.entityId}/reply/illegal-content`,
        ),
    },
    {
      separatorName: 'Moderate',
    },
    // {
    //   name: 'Submit as inaccurate',
    //   icon: 'report-inaccurate',
    //   handler: () =>
    //     this.navController.navigateForward(
    //       `/report/${this.item.entityId}/reply/inaccurate`,
    //     ),
    // },
    {
      name: 'Submit as inappropriate',
      icon: 'report-inappropriate',
      handler: () =>
        this.navController.navigateForward(
          `/report/${this.item.entityId}/reply/inappropriate`,
        ),
    },
  ];

  constructor(private navController: NavController) {}
}
